module.exports = __webpack_public_path__ + "static/media/iltoo.ea7f39e0.jpg";